module.exports = __webpack_public_path__ + "img/savory_inactive.9bfcb48e.png";